import { apiUrl } from '../../../config/config'
import { get_course_by_id } from '../../../db/learning'
import { sendRequest } from '../../../utils/FetchServices'
import { Platform } from 'react-native'
/**
 *
 * @param {*} data debe llegar con sesta estructura { course_id, course_status ,moduls ,authToken }
 * @returns devuelve la respuesta de la request a save_progress_training
 */
export const save_progress_training_request = async (data, data_update_devices_users) => {
    const { authToken, course_id, course_status, moduls } = data
    try {
        if (data) {
            const response = await fetch(`${apiUrl}/save_progress_training`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    course_id: course_id,
                    status: course_status,
                    moduls: moduls,
                },
            })

            // console.log('🚀 ~ file: index.js:125 ~ constsave_progress_training_request= ~ response:', response)

            if (!response.ok) {
                console.log('response error: ', JSON.stringify(response, null, 2))
                throw new Error('Fallo al updatear progreso')
            }

            let responseData = await response.json()

            //console.log('31 🍎🍎🍎 ~ data_update_devices_users:', data_update_devices_users)
            if (data_update_devices_users) {
                await update_devices_users(data_update_devices_users)
            }

            return responseData
        } else {
            throw new Error('Fallo al updatear progreso, falta o no llega info ')
        }
    } catch (error) {
        console.error('Error en save_progress_training:', error)
        // throw new Error('error en save_progress_training: ', error)
    }
}

/**
 *
 * @param {*} current_course curso actual
 * @returns devuelve los modulos del curso actual con la siguiente estructura [{ _id: modul._id, status: modul.status }]
 */
export const module_structure = (current_course) => {
    if (!current_course || !current_course.moduls) {
        console.error('Invalid current_course in module_structure:', current_course)
        return []
    }
    const modulos = current_course.moduls
    // console.log('🚀 llega estpoooooooooooo~ modulos:', modulos)

    const update_contents = modulos.map((modul) => ({
        _id: modul._id,
        status: modul.status,
    }))

    return update_contents
}

/**
 *
 * @param {*} update data a updatear, tiene que venir : [{module: current, status: COMPLETED},{module: next_content,status: PENDIENTE}]
 * @param {*} current_course curso actual
 * @returns devuelve { _id: modul._id, status: modul.status } con los satus updateados y parseados listos para mandarlos a la request
 */
export const module_structure_update = async (database, update, current_course) => {
    // console.log('🚀 ~1 current_course:', current_course._id)
    let courseToUse = current_course
    // if (Platform.OS !== 'web') {
    //     // En apps nativas, busca la versión más reciente de la DB local
    //     const course = await get_course_by_id(database, current_course._id)
    //     console.log("🚀 ~ module_structure_update ~ course:", course)
    //     if (course) {
    //         courseToUse = course
    //     } else {
    //         console.warn('Course not found in local DB, using current_course')
    //     }
    // }

    // console.log('courseToUse =====> courseToUse: ', courseToUse)

    // En web, usa directamente el objeto current_course
    let modulos = module_structure(courseToUse)
    const update_contents = modulos.map((modul) => {
        const foundModule = update.find((item) => item.module._id.toString() === modul._id.toString())
        return foundModule ? { _id: modul._id, status: foundModule.status } : { _id: modul._id, status: modul.status }
    })

    return update_contents
}

export const save_assessment_request = async (data, data_update_devices_users) => {
    //const { authToken, evaluation_id, course_id, content_id, answers } = data

    try {
        const URL = `${apiUrl}/save_assessment`
        let headers = {
            Authorization: data.authToken,
            evaluation_id: data.evaluation_id,
            course_id: data.course_id,
            content_id: data.content_id,
        }
        let body = {
            answers: data.answers,
        }
        const data_resp = await sendRequest(URL, 'POST', headers, body, 0, 25)
        return data_resp
        // const response = await fetch(`${apiUrl}/save_assessment`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         Authorization: data.authToken,
        //         evaluation_id: data.evaluation_id,
        //         course_id: data.course_id,
        //         content_id: data.content_id,
        //     },
        //     body: JSON.stringify({
        //         answers: data.answers,
        //     }),
        // })

        //console.log('eeeeerrrrrorrr constsave_assessment_request= ~ response:', response)
        // if (!response.ok) {
        //     throw new Error('Fallo save_assessment')
        // }
        // let responseData = await response.json()
        // console.log('🚀/////1~ responseData evaluation:', responseData)
        // if (data_update_devices_users) {
        //     await update_devices_users(data_update_devices_users)
        // }
        // return responseData
    } catch (error) {
        console.error('101 Error en save_assessment_request:', error)
        throw new Error('102 error en save_assessment_request: ', error)
    }
}

export const save_survey_request = async (data) => {
    const { authToken, post_id, survey_id, answers, course_id } = data

    try {
        const URL = `${apiUrl}/save_survey`
        const headers = {
            Authorization: authToken,
            survey_id: survey_id,
            post_id: post_id,
            course_id: course_id,
            // answers: answers,
        }
        let body = {
            answers: answers,
        }

        const data = await sendRequest(URL, 'POST', headers, body, 0, 7)
        if (data && data.status && data.status === 1) {
            return data.response
        } else {
            return null
        }
        // const response = await fetch(`${apiUrl}/save_survey`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         Authorization: authToken,
        //         survey_id: survey_id,
        //         post_id: post_id,
        //         course_id: course_id,
        //         answers: answers,
        //     },
        // })

        // if (!response.ok) {
        //     throw new Error('Fallo al guardar la encuesta')
        // }
        // let responseData = await response.json()

        // return responseData
    } catch (error) {
        console.error('Error en save_survey_request:', error)
        throw new Error('error en save_survey_request: ', error)
    }
}

export const update_devices_users = async (data) => {
    // console.log('🍎 140 🚀 empiezo update_devices_users ~ const update_devices_users= ~ data:', data)
    try {
        const response = await fetch(`${apiUrl}/update_devices_users`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: data.authToken,
                device_key: data.device_key,
                table: data.table,
            },
        })
        if (!response.ok) {
            throw new Error('Fallo al update_devices_users')
        }
        let responseData = await response.json()
        //console.log('🚀🚀🚀🚀🚀 151 ~ responseData:', JSON.stringify(responseData, null, 2))

        return responseData
    } catch (error) {
        console.error('154 Error en update_devices_users:', error)
        throw new Error('155 error en update_devices_users: ', error)
    }
}
